export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const SELECT_LOS_IMPORT_FAILURE = 'SELECT_LOS_IMPORT_FAILURE';
export const SET_LOAN_PROGRAMS = 'SET_LOAN_PROGRAMS';
export const SET_LOAN_SUBTYPES = 'SET_LOAN_SUBTYPES';
export const SET_IMPORT_FAILURES = 'SET_IMPORT_FAILURES';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_TABLE_OPTIONS = 'SET_TABLE_OPTIONS';
export const SET_DATE_FILTER = 'SET_DATE_FILTER';
